module.exports = __webpack_public_path__ + "static/media/27OCHA14.b8d8c9a7.jpg";